const LOCAL_STORAGE_KEY = 'MANAGER_SHELL_DEBUG';
function isDebugActivated() {
    const managerShellDebug = localStorage.getItem(LOCAL_STORAGE_KEY);
    return ['true', '1'].includes(managerShellDebug);
}
function consoleLogger(type) {
    const console = window.console || {};
    const loggerFn = console[type] || console.log;
    return function log(...args) {
        return isDebugActivated()
            ? Function.prototype.apply.call(loggerFn, console, args)
            : undefined;
    };
}
function logger() {
    return {
        log: consoleLogger('log'),
        info: consoleLogger('info'),
        warn: consoleLogger('warn'),
        error: consoleLogger('error'),
        debug: consoleLogger('debug'),
    };
}
export function clientLogger(shellClient) {
    return {
        log: (...args) => shellClient.invokePluginMethod({
            plugin: 'logger',
            method: 'log',
            args,
        }),
        info: (...args) => shellClient.invokePluginMethod({
            plugin: 'logger',
            method: 'info',
            args,
        }),
        warn: (...args) => shellClient.invokePluginMethod({
            plugin: 'logger',
            method: 'warn',
            args,
        }),
        error: (...args) => shellClient.invokePluginMethod({
            plugin: 'logger',
            method: 'error',
            args,
        }),
        debug: (...args) => shellClient.invokePluginMethod({
            plugin: 'logger',
            method: 'debug',
            args,
        }),
    };
}
export default logger;
//# sourceMappingURL=index.js.map